module.exports = __webpack_public_path__ + "static/media/students-img1.fe1291a8.svg";